import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async handleClick(event) {
    event.preventDefault()

    const link = event.currentTarget
    const bulkAction = link.dataset.bulkAction
    const date = link.dataset.date
    const scheduleId = link.dataset.scheduleId

    // Fetch count
    try {
      const url = new URL(`/branch/schedules/${scheduleId}/occurrences/bulk_count`, window.location.origin)
      url.searchParams.append('date', date)

      console.log('Fetching from URL:', url.toString())
      console.log('Schedule ID:', scheduleId, 'Date:', date)

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      })

      if (!response.ok) {
        const errorText = await response.text()
        console.error('Response status:', response.status, 'Body:', errorText)
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      // Populate modal
      document.getElementById('bulk-action-type').textContent =
        bulkAction === 'cancel' ? 'cancel' : 'delete'
      document.getElementById('bulk-occurrence-count').textContent = data.count
      document.getElementById('bulk-action-date').textContent =
        new Date(date + 'T00:00:00').toLocaleDateString()

      // Store for confirmation
      this.pendingAction = { bulkAction, date, scheduleId }

      // Setup confirm button
      const confirmBtn = document.getElementById('bulk-confirm-btn')
      confirmBtn.onclick = () => this.confirm()

      // Get or create modal
      const modalElement = document.getElementById('bulkActionModal')
      if (!modalElement) {
        console.error('Modal not found')
        alert('Modal not found on page')
        return
      }

      const modal = new bootstrap.Modal(modalElement)
      modal.show()
    } catch (error) {
      console.error('Error fetching bulk count:', error)
      alert('An error occurred: ' + error.message)
    }
  }

  async confirm() {
    const { bulkAction, date, scheduleId } = this.pendingAction

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      const response = await fetch(
        `/branch/schedules/${scheduleId}/occurrences/bulk_${bulkAction}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(csrfToken && { 'X-CSRF-Token': csrfToken })
          },
          body: JSON.stringify({ date })
        }
      )

      if (response.ok) {
        const modalElement = document.getElementById('bulkActionModal')
        const modal = bootstrap.Modal.getInstance(modalElement)
        if (modal) modal.hide()
        // Refresh the page to show updated calendar
        window.location.reload()
      } else {
        const errorText = await response.text()
        console.error('Response status:', response.status, 'Body:', errorText)
        alert('An error occurred: ' + response.status)
      }
    } catch (error) {
      console.error('Error performing bulk action:', error)
      alert('An error occurred: ' + error.message)
    }
  }
}
